import { render, staticRenderFns } from "./MesasDeExamenes.vue?vue&type=template&id=0c212d9f&"
import script from "./MesasDeExamenes.vue?vue&type=script&lang=js&"
export * from "./MesasDeExamenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports